export default __webpack_public_path__ + "static/media/thanal_logo.706e883a.png";